const PROD_HOSTS = new Set(["voltyshare.com", "www.voltyshare.com"]);

export const getRuntimeEnv = () => {
  const explicit = String(import.meta.env.VITE_APP_ENV || "").toLowerCase();
  if (explicit) return explicit;
  if (typeof window === "undefined") return "production";
  return PROD_HOSTS.has(window.location.hostname) ? "production" : "staging";
};

export const isProductionRuntime = () => getRuntimeEnv() === "production";

export const isNonProductionRuntime = () => !isProductionRuntime();

export const getRuntimeEnvLabel = () => getRuntimeEnv().toUpperCase();

export const getPublicSiteUrl = () => {
  const explicit = String(import.meta.env.VITE_PUBLIC_SITE_URL || "").replace(/\/$/, "");
  if (explicit) return explicit;
  if (typeof window !== "undefined" && PROD_HOSTS.has(window.location.hostname)) {
    return `${window.location.protocol}//${window.location.hostname}`;
  }
  return "https://www.voltyshare.com";
};

export const getPublicUrl = (path: string) => {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return new URL(normalizedPath, `${getPublicSiteUrl()}/`).toString();
};
